const quotationChat = {
  quotationChatNavLabel: "Chat ng Sipi", // translated 
  quotationChatApprovalTitle: "Chat ng Sipi", // translated 
  quotationChatAccountNotApprovedTitle: "Hindi Naaprubahan ang Account", // translated 
  quotationChatAccountNotApprovedDescription:
    "Hindi pa naaaprubahan ang iyong account. Mangyaring makipag-ugnayan sa iyong account manager para sa karagdagang impormasyon.", // translated 
  quotationChatViewAiChat: "Tingnan ang A.I. Chat", // translated 

  quotationRequestChatSessions: "Mga Sesyon ng Chat", // translated 
  quotationRequestChatNoPastSessions: "Walang mga nakaraang sesyon", // translated 
  quotationRequestChatNewChat: "Bagong Chat", // translated 
  quotationRequestChatCloseSidebar: "Isara ang sidebar", // translated 
  quotationRequestChatSessionFallback: "Sesyon ng Pakikipag-chat", // translated 
  quotationRequestChatDefaultSessionName: "Bagong Sesyon ng Chat", // translated 
  quotationRequestChatTitle: "Chat para sa Paghingi ng Sipi", // translated 
  quotationRequestChatResponseLanguageLabel: "Wikang tugon", // translated 
  quotationRequestChatOpenSidebar: "Buksan ang sidebar", // translated 
  quotationRequestChatRenameSession: "Palitan ang pangalan ng sesyon", // translated 
  quotationRequestChatDeleteSession: "Burahin ang sesyon", // translated 
  quotationRequestChatToggleDarkMode: "I-toggle ang dark mode", // translated 
  quotationRequestChatSwitchToLightMode: "Lumipat sa light mode", // translated 
  quotationRequestChatSwitchToDarkMode: "Lumipat sa madilim na mode", // translated 
  quotationRequestChatEmptyStateHeading: "Magsimula ng Bagong Usapan Tungkol sa Paghiling ng Sipi", // translated 
  quotationRequestChatEmptyStateSubheading:
    "Ilarawan ang iyong mga pangangailangan sa paglalakbay at gagawa ako ng kahilingan para sa sipi para sa iyo.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "I-type ang iyong mensahe para magsimula ng pag-uusap... (Shift+Enter para sa bagong linya)", // translated 
  quotationRequestChatMessagePlaceholder: "I-type ang iyong mensahe... (Shift+Enter para sa bagong linya)", // translated 
  quotationRequestChatUploadFile: "Mag-upload ng file", // translated 
  quotationRequestChatUploadAttachment: "Mag-upload ng kalakip", // translated 

  quotationRequestChatStopGenerating: "Itigil ang pagbuo", // translated 
  quotationRequestChatGenerateQuotation: "Gumawa ng sipi", // translated 
  quotationRequestChatGenerateFinalQuotation: "Bumuo ng Pangwakas na Sipi", // translated 
  quotationRequestChatFinalizeQuotationRequest: "Tapusin ang Kahilingan sa Sipi", // translated 
  quotationRequestChatHoldToRecord: "Pindutin nang matagal para i-record ang mensahe ng boses", // translated 
  quotationRequestChatRecordingReleaseToSend: "Pagre-record, paglabas upang ipadala", // translated 
  quotationRequestChatRecording: "Nagre-record...", // translated 
  quotationRequestChatSelectSessionFirst: "Pumili muna ng sesyon ng chat.", // translated 
  quotationRequestChatCancelVoiceRecording: "Kanselahin ang pag-record ng boses", // translated 
  quotationRequestChatListening: "Nakikinig...", // translated 
  quotationRequestChatTranscribing: "Tinatranskrip...", // translated 

  quotationRequestChatFileUploadedSuccess: "Matagumpay na na-upload ang file.", // translated 
  quotationRequestChatUnsupportedFileType: "Hindi suportadong uri ng file. Mag-upload ng PDF, Word (.docx), Excel (.xlsx), PowerPoint (.pptx), text/CSV, o larawan.", // translated
  quotationRequestChatFailedCreateSession: "Nabigong lumikha ng sesyon ng chat. Pakisubukang muli.", // translated 
  quotationRequestChatFailedUploadFile: "Nabigong i-upload ang file. Pakisubukang muli.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "Pakisagot ang mga nakabinbing tanong bago magpadala ng isa pang mensahe.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Pakisagot ang mga nakabinbing tanong bago tapusin ang kahilingan para sa sipi.", // translated 
  quotationRequestChatFavoriteMarked: "Minarkahan ang sesyon ng chat bilang paborito", // translated 
  quotationRequestChatFavoriteUnmarked: "Hindi minarkahan bilang paborito ang sesyon ng chat", // translated 
  quotationRequestChatFailedSetFavorite: "Nabigong itakda ang paborito", // translated 
  quotationRequestChatFailedUnsetFavorite: "Nabigong alisin sa pagkakatakda ang paborito", // translated 
  quotationRequestChatRenamedSuccess: "Matagumpay na napalitan ang pangalan ng sesyon ng chat.", // translated 
  quotationRequestChatFailedRename: "Nabigong palitan ang pangalan ng sesyon ng chat. Pakisubukang muli.", // translated 
  quotationRequestChatDeletedSuccess: "Matagumpay na nabura ang sesyon ng chat.", // translated 
  quotationRequestChatFailedDelete: "Nabigong burahin ang sesyon ng chat. Pakisubukang muli.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "Matagumpay na nabura ang kalakip.", // translated 
  quotationRequestChatFailedDeleteAttachment: "Nabigong burahin ang kalakip. Pakisubukang muli.", // translated 
  quotationRequestChatSubmittedSuccess:
    "Matagumpay na naisumite ang kahilingan sa sipi! Pinoproseso na ang iyong kahilingan.", // translated 
  quotationRequestChatFailedSubmit: "Nabigong magsumite ng kahilingan sa sipi", // translated 
  quotationChatPdfDownloadedSuccess: "Matagumpay na na-download ang PDF!", // translated 
  quotationChatFailedGeneratePdf: "Nabigong makabuo ng PDF", // translated 

  quotationRequestChatSubagentRequired:
    "Mangyaring pumili ng isang sub-agent user bago isumite ang kahilingan sa quotation.", // translated 
  quotationRequestChatAppUserLoading:
    "Naglo-load pa rin ang profile ng iyong CRM app user. Pakisubukang muli maya-maya.", // translated 
  quotationRequestChatAppUserMismatch:
    "Hindi tugma ang profile ng iyong CRM app user sa chat session na ito.", // translated 

  quotationRequestChatRenameTitle: "Palitan ang Pangalan ng Sesyon ng Chat", // translated 
  quotationRequestChatSessionName: "Pangalan ng Sesyon", // translated 
  quotationRequestChatEnterSessionName: "Ilagay ang pangalan ng sesyon", // translated 
  quotationRequestChatSaving: "Nagse-save...", // translated 
  quotationRequestChatSave: "I-save", // translated 
  quotationRequestChatDeleteTitle: "Burahin ang Sesyon ng Chat", // translated 
  quotationRequestChatDeleteConfirm: "Sigurado ka bang gusto mong burahin ang sesyon ng chat na ito?", // translated 
  quotationRequestChatDeleteCannotUndo: "Hindi na maaaring bawiin ang aksyon na ito.", // translated 
  quotationRequestChatDeleting: "Tinatanggal...", // translated 
  quotationRequestChatDelete: "Burahin", // translated 

  quotationRequestChatAttachmentsTitle: "Mga Kalakip sa Chat para sa Kahilingan sa Sipi", // translated 
  quotationRequestChatLoadingAttachments: "Naglo-load ng mga attachment...", // translated 
  quotationRequestChatNoAttachments: "Walang nakitang mga kalakip", // translated 
  quotationRequestChatDeleteAttachment: "Burahin ang kalakip", // translated 
  quotationRequestChatUploadingAttachment: "Ina-upload ang kalakip...", // translated 
  quotationRequestChatUploadingAttachmentWait: "Mangyaring maghintay habang ina-upload ang iyong file.", // translated 

  quotationRequestChatAnswerPendingQuestions: "Sagutin ang mga Nakabinbing Tanong", // translated 
  quotationRequestChatProposeOwnAnswer: "Magmungkahi ng sarili kong sagot", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "I-type ang sarili mong sagot...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{sinagot}} ng {{kabuuan}} ang nasagot", // translated 
  quotationRequestChatReadyToSubmit: "Handa nang isumite", // translated 
  quotationRequestChatSubmitAll: "Isumite lahat", // translated 
  quotationRequestChatRespondToOneQuestion: "Sagutin ang tanong na {{count}}", // translated 
  quotationRequestChatRespondToManyQuestions: "Sumagot sa mga tanong na {{count}}", // translated 

  quotationRequestChatFinalizeTitle: "Tapusin ang Kahilingan sa Sipi", // translated 
  quotationRequestChatLoadingSessionData: "Naglo-load ng datos ng sesyon...", // translated 
  quotationRequestChatErrorLoadingSession: "Nagka-error sa paglo-load ng data ng sesyon. Pakisubukang muli.", // translated 
  quotationRequestChatQuotationTitle: "Pamagat ng Sipi", // translated 
  quotationRequestChatExtraComments: "Mga Dagdag na Komento", // translated 
  quotationRequestChatSubmitting: "Isinusumite...", // translated 
  quotationRequestChatSubmit: "Isumite", // translated 
  quotationRequestChatSubmittingOverlayTitle: "Isinusumite ang kahilingan para sa sipi...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "Mangyaring maghintay habang isinusumite ang iyong kahilingan para sa sipi.", // translated 

  quotationRequestChatSelectSubagent: "Pumili ng Sub-ahente", // translated 
  quotationRequestChatSearchSubagents: "Maghanap ng mga sub-agent...", // translated 
  quotationRequestChatLoadingSubagents: "Naglo-load ng mga sub-agent...", // translated 
  quotationRequestChatNoSubagentsFound: "Walang natagpuang mga sub-agent", // translated 
  quotationRequestChatNoSubagentsAvailable: "Walang available na mga sub-agent", // translated 
  quotationRequestChatSelectedSubagent: "Napili: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "Mga Gumagamit ng Sub-ahente", // translated 
  quotationRequestChatSearchUsers: "Maghanap ng mga user...", // translated 
  quotationRequestChatNoUsersFound: "Walang nakitang mga user", // translated 
  quotationRequestChatNoUsersAvailable: "Walang magagamit na mga user", // translated 

  quotationChatDownloadSummaryTitle: "I-download ang Buod ng Iyong Sipi", // translated 
  quotationChatDownloadSummaryDescription:
    "Punan ang iyong mga detalye sa ibaba upang makabuo ng personalized na buod ng iyong sipi sa biyahe sa PDF. Isasama sa PDF ang lahat ng detalye ng biyahe, destinasyon, impormasyon sa transportasyon, at pang-araw-araw na itineraryo.", // translated 
  quotationChatCustomerTitle: "Pamagat", // translated 
  quotationChatSelectTitle: "Pumili ng pamagat", // translated 
  quotationChatHonorificMr: "G.", // translated 
  quotationChatHonorificMrs: "Ginang", // translated 
  quotationChatHonorificMs: "MS.", // translated 
  quotationChatHonorificDr: "Dr.", // translated 
  quotationChatHonorificProf: "Prof.", // translated 
  quotationChatCustomerPhone: "Telepono", // translated 
  quotationChatCustomerCompany: "Kumpanya", // translated 
  quotationChatCustomerMessage: "Mensahe", // translated 
  quotationChatCustomerCountry: "Bansa", // translated 
  quotationChatGenerating: "Bumubuo...", // translated 
  quotationChatDownloadPdf: "I-download ang PDF", // translated 

  quotationChatTripSummary: "Buod ng Biyahe", // translated 
  quotationChatDownloadAsPdf: "I-download bilang PDF", // translated 
  quotationChatNoTripSummary: "Walang buod ng biyahe na magagamit para sa sesyon na ito.", // translated 

  quotationRequestChatThinking: "Nag-iisip...", // translated 
  quotationRequestChatSources: "Mga Pinagmumulan", // translated 
  quotationRequestChatSearchingWebFor: 'Hinahanap sa web ang: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "Mga Serbisyong Isinasagawa ng Tour Operator", // translated 
  quotationRequestChatServicesByCustomer: "Mga Serbisyong Hinahawakan ng Customer", // translated 
  quotationRequestChatReadyNotice:
    "Maaari ka na ngayong bumuo ng isang sipi para sa kahilingang ito sa pamamagitan ng pag-click sa buton sa kanan.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "Bumuo ng pangwakas na sipi", // translated 

  quotationRequestChatMaybeYouWantToAsk: "Baka gusto mong itanong:", // translated 
  quotationRequestChatClickToSendSuggestion: "I-click para ipadala ang mensaheng ito", // translated 

  quotationRequestChatAddToFavorites: "Idagdag sa mga paborito", // translated 
  quotationRequestChatRemoveFromFavorites: "Alisin sa mga paborito", // translated 
  quotationRequestChatSubmitted: "Isinumite", // translated 

  quotationRequestChatQuotationRequest: "Kahilingan sa Pagbanggit: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{pamagat}}", // translated 
  quotationRequestChatQuotationTooltipStatus: "- Katayuan: {{katayuan}}", // translated 

  quotationChatLoading: "Naglo-load...", // translated 
  quotationChatSessionNotFound: "Hindi natagpuan ang sesyon ng chat para sa sipi na ito", // translated 
  quotationChatMemberSessionNotFound: "Hindi natagpuan ang sesyon ng miyembro para sa iyong account", // translated 
  quotationChatUnableToConnect: "Hindi makakonekta sa chat", // translated 
  quotationChatConnecting: "Kumokonekta...", // translated 
  quotationChatTypeYourMessage: "i-type mo ang mensahe mo...", // translated 
  quotationChatConnected: "Nakakonekta", // translated 
  quotationChatConnectingStatus: "Kumokonekta...", // translated 
  quotationChatDisconnected: "Naputol ang koneksyon", // translated 
};


export default quotationChat;
